import { Component, Input } from '@angular/core';
import { CloudSummary } from '../../core/services/cloud.service';

@Component({
  selector: 'app-cloud-summary-bar',
  template: `
    <!-- Compact account chip; the full role ARN + region live in a hover/focus
         disclosure so technical detail stays out of the default toolbar. -->
    <div class="group relative">
      <button
        type="button"
        class="flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-2.5 py-1 text-xs text-slate-700 transition-colors hover:border-slate-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-400"
        aria-label="Connection details"
      >
        <lucide-icon name="cloud" [size]="13" class="flex-shrink-0 text-slate-400" [strokeWidth]="1.75"></lucide-icon>
        <span class="font-mono font-medium">{{ summary.accountId }}</span>
        <lucide-icon name="chevron-down" [size]="12" class="text-slate-400 transition-transform group-hover:rotate-180 group-focus-within:rotate-180" [strokeWidth]="2"></lucide-icon>
      </button>

      <div
        role="tooltip"
        class="pointer-events-none absolute right-0 top-full z-20 mt-2 w-72 rounded-lg border border-slate-200 bg-white p-3 text-xs opacity-0 shadow-lg transition-opacity duration-150 group-hover:opacity-100 group-focus-within:opacity-100"
      >
        <p class="mb-2 text-[11px] font-semibold uppercase tracking-wide text-slate-400">Connection</p>
        <dl class="space-y-1.5">
          <div class="flex items-center justify-between gap-4">
            <dt class="text-slate-400">Account</dt>
            <dd class="font-mono font-medium text-slate-700">{{ summary.accountId }}</dd>
          </div>
          <div class="flex items-center justify-between gap-4">
            <dt class="text-slate-400">Region</dt>
            <dd class="font-mono font-medium text-slate-700">{{ scopeLabel }}</dd>
          </div>
          <div>
            <dt class="mb-0.5 text-slate-400">Role</dt>
            <dd class="break-all font-mono text-slate-600">{{ summary.roleArn }}</dd>
          </div>
        </dl>
      </div>
    </div>
  `,
})
export class CloudSummaryBarComponent {
  @Input() summary!: CloudSummary;

  get scopeLabel(): string {
    const scope = this.summary?.scope ?? this.summary?.region;
    return scope === 'all' ? 'All regions' : scope;
  }
}
